import { render, staticRenderFns } from "./QrcodeActive.vue?vue&type=template&id=6032e35f&scoped=true&"
import script from "./QrcodeActive.vue?vue&type=script&lang=js&"
export * from "./QrcodeActive.vue?vue&type=script&lang=js&"
import style0 from "./QrcodeActive.vue?vue&type=style&index=0&id=6032e35f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6032e35f",
  null
  
)

component.options.__file = "QrcodeActive.vue"
export default component.exports